const messages = {
	EMAIL_NOT_VERIFIED: 'Подтвердите email, прежде чем входить в систему.',
	INVALID_CREDENTIALS: 'Неверный email или пароль.',
	INVALID_TOKEN: 'Ссылка недействительна или устарела.',
	INVALID_ACCESS_TOKEN: 'Сессия недействительна. Войдите снова.',
	INVALID_REFRESH_TOKEN: 'Сессия завершена. Войдите снова.',
	INVALID_REQUEST: 'Проверьте введённые данные.',
	RATE_LIMITED: 'Слишком много попыток. Повторите позже.',
	ORIGIN_NOT_ALLOWED: 'Запрос заблокирован настройками безопасности.',
	USER_NOT_AVAILABLE: 'Пользователь недоступен.',
	NETWORK_ERROR: 'Не удалось связаться с сервером. Повторите позже.',
	INTERNAL_ERROR: 'Произошла внутренняя ошибка. Повторите позже.',
}

export class FrontendAuthError extends Error {
	constructor(code, status, cause) {
		super(messages[code] || 'Не удалось выполнить операцию.')
		this.name = 'FrontendAuthError'
		this.code = code
		this.status = status
		this.cause = cause
	}
}

export function toAuthError(error) {
	if (error instanceof FrontendAuthError) return error
	const code = error?.response?.data?.error?.code || (error?.response ? 'INTERNAL_ERROR' : 'NETWORK_ERROR')
	return new FrontendAuthError(code, error?.response?.status, error)
}

export function authErrorMessage(error) {
	return toAuthError(error).message
}
